export enum Portals {
  Administrador = 'Administrador',
  Corredores = 'Corredores',
  Servicios_Externos = 'Servicios Externos',
  Despachante = 'Despachante',
  Autogestion = 'Autogestion',
  Partners = 'Partners',
}

export enum PortalStyles {
  Primary = 'bg-primary',
  Main = 'bg-main',
  Green = 'bg-green',
  DarkGreen = 'bg-dark-green',
  Purple = 'bg-purple',
  Orange = 'bg-orange',
}

export const permissionsSistema = [
  {
    code: '1001',
    name: 'Modificar Parámetros de Sistema',
    portal: Portals.Administrador,
  },
  {
    code: '1002',
    name: 'Coberturas y Paquetes',
    portal: Portals.Administrador,
  },
  { code: '1003', name: 'Cotizaciones', portal: Portals.Administrador },
];

export const permissionsGestionUsuario = [
  {
    code: '2001',
    name: 'ABM Asegurados / Intermediarios',
    portal: Portals.Administrador,
  },
  { code: '2002', name: 'ABM Empleados SBI', portal: Portals.Administrador },
  {
    code: '2003',
    name: 'Cambio de Roles / Permisos',
    portal: Portals.Administrador,
  },
  {
    code: '2004',
    name: 'Reinicio de Password Propia',
    portal: Portals.Administrador,
  },
  {
    code: '2005',
    name: 'Reiniciar Password de Intermediarios o Asegurados',
    portal: Portals.Administrador,
  },
  {
    code: '2006',
    name: 'Reiniciar Passoword de Empleados SBI',
    portal: Portals.Administrador,
  },
];

export const permissionsGeneralAutogestion = [
  { code: '020101', name: 'Cotizador', portal: Portals.Corredores },
  {
    code: '3001',
    name: 'Listar Pólizas Cartera',
    portal: Portals.Corredores,
  },
  {
    code: '3005',
    name: 'Consultar Deuda',
    portal: Portals.Corredores,
  },
  { code: '3002', name: 'Generar Certificado', portal: Portals.Administrador },
  { code: '3003', name: 'Ver Comisiones', portal: Portals.Administrador },
  { code: '3004', name: 'Descargar Anexos', portal: Portals.Administrador },
  {
    code: '010302',
    name: 'Listar Pólizas Cartera',
    portal: Portals.Administrador,
  },
  {
    code: '010301',
    name: 'Consultar Deuda',
    portal: Portals.Administrador,
  },
  {
    code: '020201',
    name: 'Gestión EMarine',
    portal: Portals.Corredores,
  },
  {
    code: '010501',
    name: 'Consulta EMarine',
    portal: Portals.Administrador,
  },
  {
    code: '010502',
    name: 'Administrar EMarine',
    portal: Portals.Administrador,
  },
  {
    code: '040101',
    name: 'Api Corredores',
    portal: Portals.Partners,
  },
  { code: '030001', name: 'Consultar deuda', portal: Portals.Despachante },
  { code: '030003', name: 'Listar pólizas', portal: Portals.Despachante },
];

export const permissionsFianzas = [
  { code: '4001', name: 'Solicitar Cupo', portal: Portals.Corredores },
  { code: '4002', name: 'Aprobar Cupo', portal: Portals.Administrador },
  { code: '4003', name: 'Solicitar Póliza', portal: Portals.Corredores },
  { code: '4004', name: 'Aprobar Póliza', portal: Portals.Administrador },
];

export const permissionsCampaigns = [
  { code: '5001', name: 'Crear Campañas', portal: Portals.Administrador },
];

export const permissionsAccidents = [
  {
    code: '6001',
    name: 'Ingresar denuncias autos',
    portal: Portals.Servicios_Externos,
  },
  {
    code: '6002',
    name: 'Listar denuncias autos',
    portal: Portals.Administrador,
  },
  {
    code: '6003',
    name: 'Listar denuncias transporte',
    portal: Portals.Administrador,
  },
];

export const permissionsAccounts = [
  { code: '7001', name: 'Gestión de cuentas', portal: Portals.Administrador },
  {
    code: '031010',
    name: 'Actualizar póliza',
    portal: Portals.Servicios_Externos,
  },
];

export const permissionsRenewals = [
  {
    code: '010601',
    name: 'Renovaciones Automóviles',
    portal: Portals.Administrador,
  },
  {
    code: '020301',
    name: 'Renovaciones Automóviles',
    portal: Portals.Corredores,
  },
  {
    code: '010602',
    name: 'Renovaciones Multiseguro',
    portal: Portals.Administrador,
  },
  {
    code: '020302',
    name: 'Renovaciones Multiseguro',
    portal: Portals.Corredores,
  },
];

export const permissionsCommissions = [
  { code: '021601', name: 'Seguimiento de comisiones pagas', portal: Portals.Corredores },
  { code: '021602', name: 'Seguimiento de comisiones pendientes', portal: Portals.Corredores },
];

export const permissionsMultiproducto = [
  {
    code: '010801',
    name: 'Gestión Multiproducto',
    portal: Portals.Administrador,
  },
  {
    code: '020501',
    name: 'Cotizador Multiproducto',
    portal: Portals.Corredores,
  },
];

export const permissionsTransport = [
  {
    code: '010903',
    name: 'Listar póliza transporte',
    portal: Portals.Administrador,
  },
  { code: '010905', name: 'Listar embarque', portal: Portals.Administrador },
  {
    code: '010906',
    name: 'Aprobar/Rechazar embarques',
    portal: Portals.Administrador,
  },
  { code: '010907', name: 'Anular embarques', portal: Portals.Administrador },
  { code: '010908', name: 'Facturar embarques', portal: Portals.Administrador },
  {
    code: '010909',
    name: 'Configuración de Categoría',
    portal: Portals.Administrador,
  },
  {
    code: '020903',
    name: 'Listar póliza transporte',
    portal: Portals.Corredores,
  },
  { code: '020905', name: 'Listar embarque', portal: Portals.Corredores },
  { code: '020909', name: 'Crear embarque', portal: Portals.Corredores },

  {
    code: '030903',
    name: 'Listar póliza transporte',
    portal: Portals.Despachante,
  },
  { code: '030905', name: 'Listar embarque', portal: Portals.Despachante },
  { code: '030909', name: 'Crear embarque', portal: Portals.Despachante },
];

export const permissionsRentGuarantee = [
  { code: '021001', name: 'Solicitar garantía', portal: Portals.Corredores },
  {
    code: '021002',
    name: 'Listar pólizas y cotizaciones',
    portal: Portals.Corredores,
  },
  { code: '021003', name: 'Emitir póliza', portal: Portals.Corredores },
  {
    code: '011001',
    name: 'Listar pólizas y cotizaciones',
    portal: Portals.Administrador,
  },
  { code: '011002', name: 'Aprobar cotización', portal: Portals.Administrador },
  { code: '011003', name: 'Emitir póliza', portal: Portals.Administrador },
];

export const permissionsPublicPortal = [
  { code: '050101', name: 'Acceso', portal: Portals.Autogestion },
];

export const permissionsTravel = [
  { code: '021111', name: 'Cotizador', portal: Portals.Corredores },
];

export const rolesEnum = [
  { item_id: 'sbi_admin', item_text: 'Administrador' },
  { item_id: 'asegurado', item_text: 'Asegurado' },
  { item_id: 'int_corredor', item_text: 'Corredor' },
  {
    item_id: 'int_corredor_organizador',
    item_text: 'Corredor - Organizador',
  },
  {
    item_id: 'int_corredor_suscriptor',
    item_text: 'Corredor - Suscriptor',
  },
  { item_id: 'empleado_asegurado', item_text: 'Empleado asegurado' },
  { item_id: 'sbi_gerencia_tecnica', item_text: 'Gerencia técnica' },
  { item_id: 'intermediario', item_text: 'Intermediario' },
  { item_id: 'int_organizador', item_text: 'Organizador' },
  { item_id: 'sbi_suscriptor', item_text: 'Suscriptor' },
  { item_id: 'sbi_siniestros', item_text: 'Ajustador siniestros' },
  { item_id: 'sbi_campanias', item_text: 'Manejo de campañas' },
  { item_id: 'sbi_cuentas', item_text: 'Gestor cuentas' },
  { item_id: 'sbi_cartera', item_text: 'Gestor deudas' },
  { item_id: 'sbi_polizas_admin', item_text: 'Administrador cartera' },
  { item_id: 'sbi_renovacion_admin', item_text: 'Renovador' },
  { item_id: 'sbi_multiproducto_admin', item_text: 'Gestor multiproducto' },
  { item_id: 'asegurado_empresa', item_text: 'Asegurado empresa' },
  { item_id: 'despachante_aduana', item_text: 'Despachante de Aduana' },
];
